import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Equation, EquationEvaluate, EquationOptions, defaultErrorHandler } from 'react-equation'
import { defaultVariables, defaultFunctions } from 'equation-resolver'
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import { withStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import TableCell from '@material-ui/core/TableCell';
import { Co2service } from '../../services/bunkermaster/Co2service';
import { HfoCalculationService } from '../../services/bunkermaster/HfoCalculationService';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { toast } from 'react-toastify';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import clsx from "clsx";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Icon from '@material-ui/core/Icon';


import {
    FormHelperText,
    Input,
    InputLabel,
    InputBase,
} from "@material-ui/core";
//import { MathComponent } from 'mathjax-react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { styled } from '@material-ui/core/styles';
import { textAlign } from '@mui/system';

const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
}

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);


/* function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}; */

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const BootstrapInput = withStyles((theme) => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(2),
        },
    },

    input: {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.common.white,
        border: "1px solid #ced4da",
        fontSize: 16,
        width: "auto",
        padding: "10px 12px",
        height: "0.1876em",
        // marginLeft: '2.2em',
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
    },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    table:{
            border:'1px solid black',
         
    },
    td:{
        border:'1px solid black',
        textAlign:'center',
    },
    tdclr:{
        border:'1px solid black',
        color:'red',
    },
    btn1: {
        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '0 !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'

    },
    btn2: {

        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '20px !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'
    },
    btn3: {
        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '20px !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '250px !important'
    },
    btn4: {
        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '20px !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important',
        position: 'relative',
        left: '600px'
    },
    textstyles: {
        color: '#ff4717'
    },
    heading: {
        color: "#ff4717",
    },
    theadingstyles: {
        background: "rgb(26 26 49)",
        padding: "12px",
        borderTopRightRadius: "10px",
        borderTopLeftRadius: "10px",
        color: "white",
        fontSize: "16px",
    },
}));

function CIIOverview() {

    const classes = useStyles();

    return (
        <div className={classes.root}>
            {/*     <MathComponent/> */}
            <Accordion className="mainaccord pt20 " expanded={true}>
                <AccordionSummary

                /* aria-controls="panel2a-content"
                id="panel2a-header" */
                >
                    <Typography>Calculation method</Typography>
                </AccordionSummary>
                <AccordionDetails open>
                    <FormControl MuiFormGroup-row variant="outlined" className={classes.formControl + " fullwidth"}>
                        <div className={classes.root}>
                            <Box component="main" p={3} pb={2} display="flex" >
                                <Grid container>

                                    <Grid item xs={12} sm={12} md={1} ></Grid>
                                    <Grid item xs={12} sm={12} md={10} >
                                        <Grid item xs={12} sm={12} md={12}>
                                            <Box component="div" display="block">
                                                <Typography ><h6>
                                                    1 ) Attained CII<sub>ship</sub> =<EquationOptions>
                                                        <Equation
                                                            value="Annual fuel consumption x CO_2 factor /(Annual distance travelled x Capacity (DWT or GT))"
                                                        />
                                                    </EquationOptions></h6>
                                                </Typography>
                                                <br />
                                                <Typography><h6>
                                                    2 ) CII<sub>ref</sub> = a Capacity<sup>-c</sup><br /></h6>

                                                    <Typography><h6>CII<sub>ref</sub> is the reference line for a defined group of ships. a, c and Capacity in the above equation are shown in the Table 1 below.</h6>
                                                    </Typography>
                                                </Typography>
                                                <br />
                                                <Typography><h6>
                                                    3 ) Achieved Carbon Intensity Reduction = <EquationOptions>
                                                        <Equation
                                                            value="(Attained CII_ship - CII_ref)/CII_ref x 100%"
                                                        />
                                                    </EquationOptions></h6>
                                                </Typography>
                                                <br />
                                                <Typography><h6>
                                                    4 ) Required CII = <EquationOptions>
                                                        <Equation
                                                            value="(1-Z/100 )x CII_ref"
                                                        />
                                                    </EquationOptions><br /></h6>
                                                    <Typography><h6>
                                                        Z is the general reference to the reduction factor for the required annual operational CII of ship types from year 2023 to 2030,as specified in Table 2 below.</h6>  </Typography>
                                                </Typography>
                                                <br />
                                                <Typography><h6>
                                                    5 ) Rating (on 2023 reduction factor) = <EquationOptions>
                                                        <Equation
                                                            value="Attained CII_ship/(Required CII) "
                                                        />
                                                    </EquationOptions></h6>
                                                </Typography>
                                                {/* <img style={{ width: "250%" }} src="/assets/images/CalcMethod_1.jpg" alt="DataPortfolio" />  */}

                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={10} md={8}></Grid>
                                </Grid>
                            </Box>
                        </div>

                    </FormControl>
                </AccordionDetails>
                <AccordionSummary

                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Typography>Tables</Typography>
                </AccordionSummary>
                <AccordionDetails open>
                    <FormControl MuiFormGroup-row variant="outlined" className={classes.formControl + " fullwidth"}>
                    
                        <Box component="main" p={3} pb={2} display="flex">
                            <Grid container>

                                <Grid item xs={12} sm={10} md={6}>
                                    <Box
                                        component="div"
                                        display="block"
                                        style={{ marginTop: 2, cursor: "pointer" }}
                                        pr={1}
                                    >

                                        <Box component="div" display="block">
                                            <table className={classes.table}>

                                                <thead>
                                                    <tr >
                                                        <th  className={classes.table} colspan="5" class="table-dark text-center">Table 1</th>
                                                    </tr>
                                                    <tr>
                                                        <th  className={classes.table} colspan="2">Ship type</th>
                                                        <th  className={classes.table}>Capacity</th>
                                                        <th  className={classes.table}>a</th>
                                                        <th  className={classes.table}>c</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr class="bg-light text-dark">
                                                        <td  className={classes.table} rowSpan={2}>Bulk Carrier</td>
                                                        <td  className={classes.table}>279,000 DWT and above</td>
                                                        <td  className={classes.td}>279,000</td>
                                                        <td  className={classes.table}>4745</td>
                                                        <td  className={classes.table}>0.622</td>
                                                    </tr>
                                                    <tr class="bg-light text-dark">

                                                        <td  className={classes.table}>less than 279,000 DWT</td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>4745</td>
                                                        <td  className={classes.table}>0.622</td>
                                                    </tr>
                                                    <tr>
                                                        <td  className={classes.table} rowSpan={2}>Gas Carrier</td>
                                                        <td  className={classes.table}>65,000 and above</td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>14405E7</td>
                                                        <td  className={classes.table}>2.071</td>
                                                    </tr>
                                                    <tr>
                                                        <td  className={classes.table}>less than 65,000 DWT</td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>8104</td>
                                                        <td  className={classes.table}>0.639</td>
                                                    </tr>
                                                    <tr class="bg-light text-dark">
                                                        <td  className={classes.table} colspan={2}>Tanker</td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>5247</td>
                                                        <td  className={classes.table}>0.610</td>
                                                    </tr>
                                                    <tr>
                                                        <td  className={classes.table} colspan={2}>Container ship </td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>1984</td>
                                                        <td  className={classes.table}>0.489</td>
                                                    </tr>
                                                    <tr class="bg-light text-dark">
                                                        <td  className={classes.table} rowSpan={2}>General cargo ship</td>
                                                        <td  className={classes.table}>20,000 DWT and above</td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>31948</td>
                                                        <td  className={classes.table}>0.792</td>
                                                    </tr>
                                                    <tr class="bg-light text-dark">

                                                        <td  className={classes.table}>less than 20,000 DWT</td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>588</td>
                                                        <td  className={classes.table}>0.3885</td>
                                                    </tr>
                                                    <tr>
                                                        <td  className={classes.table} colspan={2}>Refrigerated cargo Carrier </td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>4600</td>
                                                        <td  className={classes.table}>0.557</td>
                                                    </tr>
                                                    <tr class="bg-light text-dark">
                                                        <td  className={classes.table} colspan={2}>Combination carrier</td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>40853</td>
                                                        <td  className={classes.table}>0.812</td>
                                                    </tr>
                                                    <tr>
                                                        <td  className={classes.table} rowSpan={3}>LNG carrier</td>
                                                        <td  className={classes.table}>100,000 DWT and above</td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>9.827</td>
                                                        <td  className={classes.table}>0.000</td>
                                                    </tr>
                                                    <tr>

                                                        <td  className={classes.table}>65,000 DWT and above, but less than 100,000 DWT</td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>14479E10</td>
                                                        <td  className={classes.table}>2.673</td>
                                                    </tr>
                                                    <tr>

                                                        <td  className={classes.table}>less than 65,000 DWT</td>
                                                        <td  className={classes.td}>65,000</td>
                                                        <td  className={classes.table}>14479E10</td>
                                                        <td  className={classes.table}>2.673</td>
                                                    </tr>
                                                    <tr class="bg-light text-dark">
                                                        <td  className={classes.table} colspan={2}>Ro-ro cargo ship (vehicle carrier)</td>
                                                        <td  className={classes.td}>GT</td>
                                                        <td  className={classes.table}>5739</td>
                                                        <td  className={classes.table}>0.631</td>
                                                    </tr>
                                                    <tr>
                                                        <td  className={classes.table} colspan={2}>Ro-ro cargo ship</td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>10952</td>
                                                        <td  className={classes.table}>0.637</td>
                                                    </tr>
                                                    <tr class="bg-light text-dark">
                                                        <td  className={classes.table} colspan={2}>Ro-ro passenger ship</td>
                                                        <td  className={classes.td}>GT</td>
                                                        <td  className={classes.table}>7540</td>
                                                        <td  className={classes.table}>0.587</td>
                                                    </tr>
                                                    <tr>
                                                        <td  className={classes.table} colspan={2}>Cruise passenger ship</td>
                                                        <td  className={classes.td}>GT</td>
                                                        <td  className={classes.table}>930</td>
                                                        <td  className={classes.table}>0.383</td>
                                                    </tr>


                                                </tbody>
                                            </table>
                                            {/* <img style={{ width: "100%" }} src="/assets/images/CIIoverviewtable1.jpg" alt="DataPortfolio" />  */}
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={12} md={1}></Grid>
                                <Grid item xs={12} sm={12} md={5} className="dashboard-right">
                                    <Grid item xs={12} sm={12} md={12}>

                                        <Box component="div" display="block">
                                            <div class="text-center">
                                                <table>
                                                    <thead>
                                                        <tr >
                                                            <th  className={classes.table} colspan={2} class="table table-bordered table-dark">Table 2</th>
                                                        </tr>
                                                        <tr>
                                                            <th  className={classes.table} scope="col">Year</th>
                                                            <th  className={classes.table} scope="col">Reduction factor relative to 2019</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr class="bg-light text-dark">
                                                            <td  className={classes.table}>2023</td>
                                                            <td  className={classes.table}>5%*</td>
                                                        </tr>
                                                        <tr>
                                                            <td  className={classes.table}>2024</td>
                                                            <td  className={classes.table}>7%</td>
                                                        </tr>
                                                        <tr class="bg-light text-dark">
                                                            <td  className={classes.table}>2025</td>
                                                            <td  className={classes.table}>9%</td>
                                                        </tr>
                                                        <tr>
                                                            <td  className={classes.table}>2026</td>
                                                            <td  className={classes.table}>11%</td>
                                                        </tr>
                                                        <tr class="bg-light text-dark">
                                                            <td  className={classes.table}>2027</td>
                                                            <td  className={classes.table}>**</td>
                                                        </tr>
                                                        <tr>
                                                            <td  className={classes.table}>2028</td>
                                                            <td  className={classes.table}>**</td>
                                                        </tr>
                                                        <tr class="bg-light text-dark">
                                                            <td  className={classes.table}>2029</td>
                                                            <td  className={classes.table}>**</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            {/* <img style={{ width: "100%", height: "auto" }} src="/assets/images/CalcCII_2.jpg" alt="DataPortfolio" />  */}
                                        </Box>
                                        <Box component="div" display="block">

                                            <p><h5>*Reduction factor Z will be starting from 5% in 2023 and 2% will be added yearly</h5></p>

                                        </Box>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={10} md={2}></Grid>
                            </Grid>
                        </Box>
                        <Box component="main" p={3} pb={2} display="flex">
                            <Grid container>

                                <Grid item xs={12} sm={10} md={10}>
                                    <p><h5>** Z factors for the years of 2027 to 2030 to be further strengthened and developed taking into account the review of the short-term measure.</h5></p>
                                </Grid>
                            </Grid>
                        </Box>



                    </FormControl>

                </AccordionDetails>
                <AccordionSummary

                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Typography>CII Rating</Typography>
                </AccordionSummary>
                <AccordionDetails open>
                    <FormControl MuiFormGroup-row variant="outlined" className={classes.formControl + " fullwidth"}>
                        <Box component="main" p={3} pb={2} display="flex">
                            <Grid container>

                                <Grid item xs={12} sm={10} md={8}>
                                    <Box
                                        component="div"
                                        display="block"
                                        style={{ marginTop: 2, cursor: "pointer" }}
                                        pr={1}
                                    >

                                        <Box component="div" display="block">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th  className={classes.table} rowspan={2} colspan={2} style={{ "line-height": "100px !important" }}>Ship type</th>
                                                        <th  className={classes.table} rowspan={2}>Capacity in CII calculation </th>
                                                        <th  className={classes.table} colspan={4}>dd vectors <br />(after exponential transformation)</th>
                                                    </tr>
                                                    <tr>
                                                        <th  className={classes.tdclr}>d1</th>
                                                        <th  className={classes.tdclr}>d2</th>
                                                        <th  className={classes.tdclr}>d3</th>
                                                        <th  className={classes.tdclr}>d4</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr class="bg-light text-dark">
                                                        <td  className={classes.table} colspan={2}>Bulk carrier</td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>0.86</td>
                                                        <td  className={classes.table}>0.94</td>
                                                        <td  className={classes.table}>1.06</td>
                                                        <td  className={classes.table}>1.18</td>
                                                    </tr>
                                                    <tr>
                                                        <td  className={classes.table} rowspan={2}>Gas carrier</td>
                                                        <td  className={classes.table}>65,000 DWT and above</td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>0.81</td>
                                                        <td  className={classes.table}>0.91</td>
                                                        <td  className={classes.table}>1.12</td>
                                                        <td  className={classes.table}>1.44</td>
                                                    </tr>
                                                    <tr>
                                                        <td  className={classes.table}>less than 65,000 DWT</td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>0.85</td>
                                                        <td  className={classes.table}>0.95</td>
                                                        <td  className={classes.table}>1.06</td>
                                                        <td  className={classes.table}>1.25</td>
                                                    </tr>
                                                    <tr class="bg-light text-dark">
                                                        <td  className={classes.table} colspan={2}>Tanker</td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>0.82</td>
                                                        <td  className={classes.table}>0.93</td>
                                                        <td  className={classes.table}>1.08</td>
                                                        <td  className={classes.table}>1.28</td>
                                                    </tr>
                                                    <tr>
                                                        <td  className={classes.table} colspan={2}>Container ship</td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>0.83</td>
                                                        <td  className={classes.table}>0.94</td>
                                                        <td  className={classes.table}>1.07</td>
                                                        <td  className={classes.table}>1.19</td>
                                                    </tr>
                                                    <tr class="bg-light text-dark">
                                                        <td  className={classes.table} colspan={2}>General cargo ship</td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>0.83</td>
                                                        <td  className={classes.table}>0.94</td>
                                                        <td  className={classes.table}>1.06</td>
                                                        <td  className={classes.table}>1.19</td>
                                                    </tr>
                                                    <tr>
                                                        <td  className={classes.table} colspan={2}>Refrigerated cargo carrier</td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>0.78</td>
                                                        <td  className={classes.table}>0.91</td>
                                                        <td  className={classes.table}>1.07</td>
                                                        <td  className={classes.table}>1.20</td>
                                                    </tr>
                                                    <tr class="bg-light text-dark">
                                                        <td  className={classes.table} colspan={2}>Combination carrier</td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>0.87</td>
                                                        <td  className={classes.table}>0.96</td>
                                                        <td  className={classes.table}>1.06</td>
                                                        <td  className={classes.table}>1.14</td>
                                                    </tr>
                                                    <tr>
                                                        <td  className={classes.table} rowspan={2}>LNG carrier</td>
                                                        <td  className={classes.table}>100,000 DWT and above</td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>0.89</td>
                                                        <td  className={classes.table}>0.98</td>
                                                        <td  className={classes.table}>1.06</td>
                                                        <td  className={classes.table}>1.13</td>
                                                    </tr>
                                                    <tr>
                                                        <td  className={classes.table}>less than 100,000 DWT</td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>0.78</td>
                                                        <td  className={classes.table}>0.92</td>
                                                        <td  className={classes.table}>1.10</td>
                                                        <td  className={classes.table}>1.37</td>
                                                    </tr>
                                                    <tr class="bg-light text-dark">
                                                        <td  className={classes.table} colspan={2}>Ro-ro cargo ship (vehicle carrier)</td>
                                                        <td  className={classes.td}>GT</td>
                                                        <td  className={classes.table}>0.86</td>
                                                        <td  className={classes.table}>0.94</td>
                                                        <td  className={classes.table}>1.06</td>
                                                        <td  className={classes.table}>1.16</td>
                                                    </tr>
                                                    <tr>
                                                        <td  className={classes.table} colspan={2}>Ro-ro cargo ship</td>
                                                        <td  className={classes.td}>DWT</td>
                                                        <td  className={classes.table}>0.66</td>
                                                        <td  className={classes.table}>0.90</td>
                                                        <td  className={classes.table}>1.11</td>
                                                        <td  className={classes.table}>1.37</td>
                                                    </tr>
                                                    <tr class="bg-light text-dark">
                                                        <td  className={classes.table} colspan={2}>Ro-ro passenger ship</td>
                                                        <td  className={classes.td}>GT</td>
                                                        <td  className={classes.table}>0.72</td>
                                                        <td  className={classes.table}>0.90</td>
                                                        <td  className={classes.table}>1.12</td>
                                                        <td  className={classes.table}>1.41</td>
                                                    </tr>
                                                    <tr>
                                                        <td  className={classes.table} colspan={2}>Cruise passenger ship</td>
                                                        <td  className={classes.td}>GT</td>
                                                        <td  className={classes.table}>0.87</td>
                                                        <td  className={classes.table}>0.95</td>
                                                        <td  className={classes.table}>1.06</td>
                                                        <td  className={classes.table}>1.16</td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                            {/* <img style={{ width: "100%" }} src="/assets/images/CIIRating_1.jpg" alt="DataPortfolio" />   */}

                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={10} md={1}></Grid>
                                <Grid item xs={12} sm={10} md={3} className="dashboard-right">
                                    <Grid item xs={12} sm={12} md={12}>

                                        <Box component="div" display="block">

                                            <img style={{ width: "100%" }} src="/assets/images/CIIRating_2.jpg" alt="DataPortfolio" /> 

                                        </Box>

                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={10} md={2}></Grid>
                            </Grid>
                        </Box>




                    </FormControl>

                </AccordionDetails>
            </Accordion>

        </div>
    );
}
export default CIIOverview;